import { C } from '../../lib/tokens.js';
import { t } from '../../lib/data.js';
import { useLookups } from '../../lib/LookupsContext.jsx';
import { findLookup } from './Chips.jsx';

// Billing type of a request type (R_RequestType billing_type): F free, B free once accepted as
// a bug, Q paid after an accepted quote, S sponsored (cost shared), I internal.
// F/I/unknown have no marker (null).
export function billingMeta(billingType) {
  switch (billingType) {
    case 'B': return { icon: 'money_off', color: C.billBug,     stripe: C.billBug,     label: t('billing.B.short') };
    case 'Q': return { icon: 'euro',      color: C.billQuote,   stripe: C.billQuote,   label: t('billing.Q.short') };
    case 'S': return { icon: 'groups',    color: C.billSponsor, stripe: C.billSponsor, label: t('billing.S.short') };
    default:  return null;
  }
}

// Resolves a request's billing type through the request-type lookup.
export function useBillingType(req) {
  const { requestTypes } = useLookups() ?? {};
  return findLookup(requestTypes ?? [], req?.type)?.billing_type ?? null;
}

// Compact chips on request cards and rows, only for billable requests (core IsInvoiced = Y):
// "Billable", and "-N%" next to it when a suggested discount is set (agents only).
export function BillingBadge({ req, size = 10 }) {
  if (!req?.billable) return null;
  const discount = Number(req.suggestedDiscount);
  const chip = { fontFamily: 'Roboto', fontSize: size, fontWeight: 500, lineHeight: 1.5, padding: '0 5px', borderRadius: 3, whiteSpace: 'nowrap' };
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
      <span title={t('billing.badge.billable')} style={{ ...chip, color: C.iron, background: C.platinum, border: `1px solid ${C.mercury}` }}>{t('billing.badge.billable')}</span>
      {Number.isFinite(discount) && discount !== 0
        ? <span title={t('billing.badge.discount')} style={{ ...chip, color: '#A86600', background: '#FCEFD9' }}>{`-${Math.abs(discount)}%`}</span>
        : null}
    </span>
  );
}
